<div class="col-md-12">
  <h3 class="">Log Report</h3>
  <hr style="margin: 0;border: hsl(0, 0%, 83%) solid 0.5px; ">
<br />
<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
  <div class="form">
      <div class="form-group row">
          <label for="UserCai" class="col-sm-2 col-form-label">Employee Name:</label>
          <div class="col-sm-4">
            {{user.Name}}
          </div>
      </div>
    
      <div class="form-group row">
        <label for="Yearlbl" class="col-sm-2 col-form-label">Year:</label>
        <div class="col-sm-4">
            <select id="Yearlbl" class="form-control" [(ngModel)]="Year" >
                <option value="0" selected>All</option>
                <option *ngFor="let _yrs of getYrs" [ngValue]="_yrs" >{{_yrs}}</option>
              </select>
          
        </div>
      </div>
     <div class="form-group row">
      <div class="col-sm-2 col-form-label"></div>
      <div class="col-sm-4">
        <button class="btn btn-primary" (click)="getVowdLog()" >Search</button>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  <table class="table table-bordered" *ngIf="vowdLog.length > 0">
    <thead>
      <tr>
          <th scope="col" >Month</th>
          <th scope="col" >Provisioning ID</th>
          <th scope="col" >Object Account</th>
          <th scope="col" >Supplier AB</th>
          <th scope="col" >Supplier Name</th>
          <th scope="col" >VOWD Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let log of vowdLog |paginate: { itemsPerPage: 10, currentPage: p}">
          <td>{{log.MonthVOWD}}</td>
          <td>{{log.CreatedBy}}</td>
          <td>{{log.ObjectAccount}}</td>
          <td>{{log.SupplierAB}}</td>
          <td>{{log.SupplierName}}</td>
          <td>{{log.Vowd| currency}}</td>
      </tr>
    </tbody>
</table>
<pagination-controls (pageChange)="p = $event" *ngIf="vowdLog.length > 0"></pagination-controls> 
</div>
